/**
 * Межі масових дій і експорту у вебі — копія сталих `@clientline/contracts` (bulk.ts): значень з
 * кореня контрактів веб не бере (zod у чанках). Одна копія на веб: її беруть і список (перший
 * екран, без лінивого `bulk/api.ts`), і потоки масових дій; збіг з контрактом звіряє
 * `bulk-delete.test.tsx`. Імпортів у файлі немає навмисно.
 */

/** `BULK_CANCEL_WINDOW_MS`: відкладений старт задачі на сервері. */
export const BULK_CANCEL_MS = 5_000;
/** `BULK_STEP_UP_THRESHOLD`: поріг step-up і введення числа. */
export const BULK_STEP_UP_OVER = 100;
/** `MAX_BULK_SELECTION_IDS`: id в одному виборі. */
export const BULK_IDS_MAX = 1000;
/** `MAX_EXPORT_FIELDS`: стовпців у файлі експорту. */
export const EXPORT_FIELDS_MAX = 100;
